import { useI18n } from "../i18n";

export default function Footer() {
  const { t } = useI18n();

  return (
    <footer className="px-4 py-6 text-center text-xs text-gray-400">
      <p>{t("footer.copyright")}</p>

      <p className="mt-2">{t("footer.analytics")}</p>

      <div className="mt-3 flex items-center justify-center gap-3">
        <a href="/privacy" className="underline hover:text-white">
          {t("footer.privacy")}
        </a>
        <a href="/terms" className="underline hover:text-white">
          {t("footer.terms")}
        </a>
        <a href="/disclaimer" className="underline hover:text-white">
          {t("footer.disclaimer")}
        </a>
      </div>

      <div className="mt-4 flex items-center justify-center gap-2 text-white/50">
        <span>{t("footer.poweredBy")}</span>

        <a
          href="https://www.mmsystems.work"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold text-primary-glow hover:text-white"
        >
          www.mmsystems.work
        </a>
      </div>
    </footer>
  );
}
